import React from "react";
import { Link, useLocation } from "react-router-dom";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Box,
  Grid,
  Button,
  CssBaseline,
  Typography,
} from "@material-ui/core";

import MainLayout from "./MainLayout";

import { copyToClipboard } from "./utils";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: theme.spacing(8),
    textAlign: "center",
  },
  total: {
    fontWeight: 700,
  },
  title: {
    marginTop: theme.spacing(2),
  },
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Review() {
  const classes = useStyles();
  const query = useQuery();

  const orderId = query.get("orderId");

  return (
    <MainLayout pageTitle={"Sipariş Başarlı"}>
      <CssBaseline />
      <Paper>
        <Box mt={2} className={classes.box}>
          <Typography variant="h2" gutterBottom>
            Teşekkürler...
          </Typography>
          <Grid container spacing={2} direction="column">
            <Grid item>
              <Typography variant="h6" gutterBottom className={classes.title}>
                Siparişiniz başarıyla alındı.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h6" gutterBottom className={classes.title}>
                Sipariş Numarası: {orderId}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to={"/"}
              >
                Sipariş Ekranına geri dön
              </Button>
            </Grid>

            <Grid item>
              <Button
                onClick={() =>
                  copyToClipboard(
                    `${window.location.origin}/sozlesmeler/kisisel-veriler`
                  )
                }
              >
                <FileCopyIcon />
                Linki Kopyala
              </Button>
              <Button
                color="primary"
                component={Link}
                target="_blank"
                to={"/sozlesmeler/kisisel-veriler"}
              >
                KVKK Aydınlatma Metni
              </Button>
            </Grid>

            <Grid item>
              <Button
                onClick={() =>
                  copyToClipboard(
                    `${window.location.origin}/sozlesmeler/${orderId}`
                  )
                }
              >
                <FileCopyIcon />
                Linki Kopyala
              </Button>
              <Button
                color="primary"
                component={Link}
                to={`/sozlesmeler/${orderId}`}
                target={"_blank"}
              >
                Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi
              </Button>
            </Grid>

            <br />
          </Grid>
        </Box>
      </Paper>
    </MainLayout>
  );
}
